//## BREAKPOINTS

// Define the breakpoints at which your layout will change, adapting to different screen sizes.

// Phone
export const lu_screen_xs = 360;

// Small Tablets
export const lu_screen_s = 840;
export const lu_screen_s_min = lu_screen_xs + 1;

// Tablets
export const lu_screen_m = 1024;
export const lu_screen_m_min = lu_screen_s + 1;

// large screens
export const lu_screen_l = 1280;
export const lu_screen_l_min = lu_screen_m + 1;

// Extra large screens
export const lu_screen_xl_min = lu_screen_l + 1;
